import React, { useEffect } from 'react';
import "./c89_luiss_slider.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { insertHtml } from "../../utils/dom";
import hexToRgb from "../../utils/utils";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Translation } from "react-i18next";

import ReactPlayer from "react-player";

import ScrollTop from "../scrolltop_component/scrolltop_component";
import ScrollToElementBtn from "../scrollToElementBtn_component/scrollToElementBtn_component";

class c89UniquenessSlider extends TemplateComponent {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.scrollElemRef = React.createRef();
        this.sliderUniqueness = React.createRef();
        console.log(props)
    };

    componentRender(data) {

        let uuid = 1;
        let arrayData = data.sliders;

        const responsive = {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 1
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 1
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1
            }
        };

        const boxStyle = (colors, opacity, img) => [
            {
                backgroundImage: 'linear-gradient(rgba(' + colors + ', ' + opacity + '), rgba(' + colors + ', ' + opacity + ')), url(' + img + ')'
            }
        ]

        return (
            <>
                {/* boxes */}
                <div className="row boxes box-shadow" ref={this.scrollElemRef} style={{ marginTop: "8vw" }}>
                    {arrayData.map((el, i) => (
                        <>
                            <div key={`${uuid++}`}
                                style={boxStyle(hexToRgb(el.color_code), 0.8, el.box_image_url)[0]}
                                className={'col-md-' + (12 / arrayData.length) + ' box d-flex flex-column justify-content-between'}>
                                <div className="content">
                                    <h2 {...insertHtml(el.box_title)}></h2>
                                    <p {...insertHtml(el.box_content)}></p>
                                </div>
                                {this.props.language === 'it' ?
                                    <div className="anchor-link">
                                        <ScrollToElementBtn el={el.box_slug} text={'Scopri di più'} />
                                    </div>
                                    :
                                    <div className="anchor-link">
                                        <ScrollToElementBtn el={el.box_slug} text={'Discover more'} />
                                    </div>
                                }
                            </div>
                        </>
                    ))}
                </div>

                {/* slider and block container */}
                <div id="uniqueness-slider" className="row" ref={this.sliderUniqueness}>
                    <div className="container-fluid p-0">

                        {arrayData.map((el, i) => (
                            <>
                                <div key={`${el.id}`} id={`${el.box_slug}`} style={boxStyle(hexToRgb(el.color_code), 1, '')[0]} className="block-content">
                                    <div className="row heading p-4" style={{ marginBottom: "-5vw" }}>
                                        <div className="col-12">
                                            <h2 {...insertHtml(el.block_title)}></h2>
                                            <p {...insertHtml(el.block_content)}></p>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginTop: "0vw" }}>
                                        <div className="col-12 container-extra-large">
                                            <div className="luiss-slider-container">
                                                <Carousel ref={el => (this.Carousel = el)}
                                                    arrows
                                                    autoPlay={false}
                                                    shouldResetAutoplay={false}
                                                    centerMode={false}
                                                    className=""
                                                    containerClass="container-with-dots"
                                                    dotListClass=""
                                                    responsive={responsive}
                                                    draggable={true}
                                                    focusOnSelect={false}
                                                    infinite={true}
                                                    minimumTouchDrag={80}
                                                    showDots={false}
                                                    sliderClass=""
                                                    itemClass="single-slide-item"
                                                    swipeable>
                                                    {el.slides.map((item, index) => (
                                                        <>
                                                            <div key={`${item.id}`} className="row slide">
                                                                {((item.image_url || item.video_url) && item.content && item.title) &&
                                                                    <div className={((item.image_url || item.video_url) && item.content && item.title) && 'col-lg-6'}>
                                                                        <div className={'scroll_down'}>
                                                                            {(item.title) ? <h2 {...insertHtml(item.title)}></h2> : null}
                                                                            <span {...insertHtml(item.content)}></span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {(item.image_url || item.video_url) &&
                                                                    <>
                                                                        <div className={((item.image_url || item.video_url) && item.content && item.title) ? 'col-lg-6' + ' media' : 'col-md-12'} style={{ position: "relative", marginBottom: "10rem" }}>
                                                                            {(item.image_url) ? <img src={item.image_url} alt="Luiss.it" className="slider-image box-shadow" /> : null}
                                                                            {(item.video_url) ? <ReactPlayer className="card-video box-shadow" url={item.video_url} ref={this.videoRef} controls={false} playing={false} /> : null}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </>
                                                    ))}
                                                </Carousel>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}

                    </div>
                </div>

                <ScrollTop height={400} scroll={this.scrollElemRef} nav={this.sliderUniqueness} />

            </>
        )
    }
}

export default c89UniquenessSlider;
